import { View, Text } from 'react-native'
import React, { useLayoutEffect, useState } from 'react'
import AsyncStorage from '@react-native-async-storage/async-storage';
import { useNavigation } from '@react-navigation/native';
import dr from './../datosReferenciales.json'
import transl from './../translations/transl'
import { useSelector } from 'react-redux';

let lang = undefined;

const Profile = () => {
  //receivedData
  const [value, setvalue] = useState('');

  const navigation = useNavigation();
  useLayoutEffect(() => {
    navigation.setOptions({
        //headerShown: false,
        headerTitle: transl('MainMenu.perfil',lang)
    })
  }, []);
  
  const readValue = async () => {
    await AsyncStorage.getItem('equipos')
    .then((value)=> {
      setvalue(value)
      if(value !== undefined)displayInfo(value)
    })
  }
  readValue()

  lang = dr.idiomas[useSelector((state) => state.language)].value

  return (
    <View>
      {
        displayInfo(value)
      }
    </View>
  )
}

function displayInfo(data){
  if(data === undefined || !data) {
    return;
  }
  data = data != null ? JSON.parse(data) : null


  let myTeamEnemy = data.others.siguientePartido
  if(myTeamEnemy > 10) {
    myTeamEnemy = myTeamEnemy - 11
    myTeamEnemy = -myTeamEnemy
  }
  
  let jornadaReal = data.others.siguientePartido
  if(data.others.vecesTodosLosPartidosHechos%2) jornadaReal += 19
  let temporadaReal = Math.floor(data.others.vecesTodosLosPartidosHechos/2)+1

  return(
    <View>
      <View style={{margin:20,paddingVertical:20,paddingHorizontal:30,backgroundColor:'#ffffff',elevation:1,borderRadius:20}}>
        <Text>{transl('Profile.nombre',lang)}: {data.profile.managerName}</Text>
        <Text>{transl('Profile.nombreEquipo',lang)}: {data.teams[0].name}</Text>
        <Text>{transl('General.galeones',lang)}: {data.profile.money}</Text>
        <Text>{transl('Roster.grageas',lang)}: {data.profile.grageas}</Text>
        <Text>{transl('Profile.puntos',lang)}: {data.teams[0].points}</Text>
        <Text>{transl('Profile.tantosFavor',lang)}: {data.teams[0].tantosF}</Text>
        <Text>{transl('Profile.tantosContra',lang)}: {data.teams[0].tantosC}</Text>
        <Text>{transl('Profile.diferenciaPuntos',lang)}: {data.teams[0].tantosF - data.teams[0].tantosC}</Text>
        <Text>{transl('Profile.partidosJugados',lang)}: {data.teams[0].partidosGanados + data.teams[0].partidosPerdidos}</Text>
        <Text>{transl('Profile.partidosGanados',lang)}: {data.teams[0].partidosGanados}</Text>
        <Text>{transl('Profile.partidosPerdidos',lang)}: {data.teams[0].partidosPerdidos}</Text>
        <Text>{transl('Profile.proximoContra',lang)}: {data.teams[myTeamEnemy + 9].name}</Text>
        <Text>{transl('Profile.jornada',lang)}: {jornadaReal}</Text>
        <Text>{transl('Profile.temporada',lang)}: {temporadaReal}</Text>
      </View>
    </View>
  )
}

export default Profile